import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { ClientGeneralParams } from "../../../../features/admin/generalParams/types";

interface MessagesSectionFormProp {
    updateField: (field: keyof ClientGeneralParams, value: any) => void;
}

export default function MessagesSectionForm({ updateField }: MessagesSectionFormProp) {
    const { t } = useTranslation(['clientParams']);
    const errors = useSelector((state: RootState) => state.clientParamsForm.errors);
    const clientParams = useSelector((state: RootState) => state.clientParamsForm.data);

    return (
        <Form>
            <Form.Group as={Row} className="mb-3 mt-4" controlId="emailUAC">
                <Form.Label column md={8}>
                    {t("clientParams:form.canSendMessageImprovementActionsToResponsibleLabel")}
                </Form.Label>
                <Col md={4} className="d-flex align-items-center">
                    <Form.Check
                        checked={clientParams.canSendMessageImprovementActionsToResponsible ?? false}
                        onChange={(e) => updateField("canSendMessageImprovementActionsToResponsible", e.target.checked)}
                        isInvalid={!!errors?.canSendMessageImprovementActionsToResponsible}
                        type="checkbox"/>
                    <Form.Control.Feedback type="invalid">
                        {errors?.canSendMessageImprovementActionsToResponsible}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3 mt-4" controlId="emailUAC">
                <Form.Label column md={8}>
                    {t("clientParams:form.canSendMessageAlertsLabel")}
                </Form.Label>
                <Col md={4} className="d-flex align-items-center">
                    <Form.Check
                        checked={clientParams.canSendMessageAlerts ?? false}
                        onChange={(e) => updateField("canSendMessageAlerts", e.target.checked)}
                        isInvalid={!!errors?.canSendMessageAlerts}
                        type="checkbox"/>
                    <Form.Control.Feedback type="invalid">
                        {errors?.canSendMessageAlerts}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3 mt-4" controlId="emailUAC">
                <Form.Label column md={8}>
                    {t("clientParams:form.canSendMessageDemandsToResponsibleLabel")}
                </Form.Label>
                <Col md={4} className="d-flex align-items-center">
                    <Form.Check
                        checked={clientParams.canSendMessageDemandsToResponsible ?? false}
                        onChange={(e) => updateField("canSendMessageDemandsToResponsible", e.target.checked)}
                        isInvalid={!!errors?.canSendMessageDemandsToResponsible}
                        type="checkbox"/>
                    <Form.Control.Feedback type="invalid">
                        {errors?.canSendMessageDemandsToResponsible}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3 mt-4" controlId="emailUAC">
                <Form.Label column md={8}>
                    {t("clientParams:form.canSendMessageImprovementPlansToResponsibleLabel")}
                </Form.Label>
                <Col md={4} className="d-flex align-items-center">
                    <Form.Check
                        checked={clientParams.canSendMessageImprovementPlansToResponsible ?? false}
                        onChange={(e) => updateField("canSendMessageImprovementPlansToResponsible", e.target.checked)}
                        isInvalid={!!errors?.canSendMessageImprovementPlansToResponsible}
                        type="checkbox"/>
                    <Form.Control.Feedback type="invalid">
                        {errors?.canSendMessageImprovementPlansToResponsible}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
        </Form>
    );
}
